import * as yup from "yup";
import dayjs from "dayjs";

export const schemas = [
  // Step 1: Personal Details
  yup.object({
    salutation: yup.string().required("Salutation is required"),
    firstName: yup.string().max(50).required("First name is required"),
    middleName: yup.string().max(50).required("Middle name is required"),
    lastName: yup.string().max(50).required("Last name is required"),
    gender: yup.string().required("Gender is required"),
    dateOfBirth: yup.string()
    // .when('$skipDobValidation', {
    //   is: true,
    //   then: (schema) => schema.notRequired(),
    //   otherwise: (schema) =>
    //     schema
    //       .required("Date of Birth is required")
    //       .transform((value) => {
    //         // Convert format only if valid date
    //         return dayjs(value, "YYYY-MM-DD").isValid()
    //           ? dayjs(value, "YYYY-MM-DD").format("DD-MM-YYYY")
    //           : value;
    //       }),
    // }),
    ,
    maritalStatus: yup.string().required("Marital Status is required"),
    fatherFirstName: yup.string().max(50).required("Father's first name is required"),
    fatherLastName: yup.string().max(50).required("Father's last name is required"),
    motherFirstName: yup.string().max(50).required("Mother's first name is required"),
    motherLastName: yup.string().max(50).required("Mother's last name is required"),
    religion: yup.string().required("Religion is required"),
    category: yup.string().required("Category is required"),
    disability: yup.string().required("Disability is required"),
    typeOfDisability: yup.string().when("disability", {
      is: "Yes",
      then: (schema) => schema.required("Type of disability is required"),
      otherwise: (schema) => schema.notRequired()
    }),
    domicileState: yup.string().required("Domicile State is required"),
    domicileDistrict: yup.string().required("Domicile District is required")
  }),
  // Step 2: Identification
  yup.object({
    idType: yup.string().required("ID Type is required"),
    alternateIdType: yup.string().required("AlternateId ID is required"),
    idNo: yup.string().min(12).max(12).when("alternateIdType", {
        is: "Aadhar ID",
        then: (schema) =>
            schema
            .required("Aadhar number is required")
            .matches(/^[0-9]{12}$/, "Aadhar number must be exactly 12 digits"),
        otherwise: (schema) =>
            schema.when("idType", {
            is: (val) => val !== "Alternate ID",
            then: (schema) => schema.required("ID Number is required"),
            otherwise: (schema) => schema.notRequired(),
        }),
    }),
  }),
  // Step 3: Contact Details
  yup.object({
    email: yup.string().email("Invalid email").max(50),
    countryCode: yup.string().required("Country code is required"),
    mobile: yup.string().matches(/^\d{10}$/, "Mobile must be 10 digits").required("Mobile is required")
  }),
  // Step 4: Address
  yup.object({
    permanentAddress: yup.string().max(50).required("Permanent address is required"),
    permanentState: yup.string().required("State is required"),
    permanentDistrict: yup.string().required("District is required"),
    permanentPin: yup.string().matches(/^\d{6}$/, "PIN must be 6 digits").required("PIN is required"),
    permanentCity: yup.string(),
    permanentTehsil: yup.string(),
    permanentConstituency: yup.string().required("Constituency is required"),
    communicationSame: yup.string().required("Please select an option"),
    communicationState: yup.string().when("communicationSame", {
      is: "No",
      then: (schema) => schema.required("Communication state is required"),
      otherwise: (schema) => schema.notRequired()
    }),
    communicationDistrict: yup.string().when("communicationSame", {
      is: "No",
      then: (schema) => schema.required("Communication district is required"),
      otherwise: (schema) => schema.notRequired()
    }),
    communicationPin: yup.string().when("communicationSame", {
      is: "No",
      then: (schema) => schema.matches(/^\d{6}$/, "PIN must be 6 digits").required("Communication PIN is required"),
      otherwise: (schema) => schema.notRequired()
    }),
    communicationCity: yup.string(),
    communicationTehsil: yup.string(),
    communicationConstituency: yup.string().when("communicationSame", {
      is: "No",
      then: (schema) => schema.required("Communication constituency is required"),
      otherwise: (schema) => schema.notRequired()
    })
  }),
  // Step 5: Education & Experience
  yup.object({
    educationLevel: yup.string().required("Education level is required"),
    trainingStatus: yup.string().required("Training status is required"),
    previousExperienceSector: yup.string().when("trainingStatus", {
      is: "Experienced",
      then: (schema) => schema.required("Previous experience sector is required"),
      otherwise: (schema) => schema.notRequired()
    }),
    monthsOfExperience: yup
    .number()
    .when(['trainingStatus', '$skipExperienceValidation'], {
      is: "Experienced",
      then: (schema) =>
        schema
          .min(1, "Must be at least 1 month")
          .max(500, "Cannot exceed 500 months")
          .required("Months of experience is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
  }),
  // Step 6: Employment Details
  yup.object({
    employed: yup.string().required("Employed is required"),
    employmentStatus: yup.string().required("Employment status is required"),
    employmentDetails: yup.string()
  }),
  // Step 7: Other/Documents
  yup.object({
    heardAboutUs: yup.string()
  })
];
